<template>
  <div class="friend-page">
    <div class="friend-bg"></div>
    <div class="friend-whitebg">
      <div class="friend-content">
        <div class="sub-btn"></div>
        <p class="friend-word">长按二维码，添加班主任</p>
        <div class="friend-qrcode">
          <img v-if="qrcode" :src="qrcode"/>
        </div>
      </div>
    </div>
    <van-dialog
      message="暂无班主任信息"
      confirmButtonText="确定"
      v-model="show">
    </van-dialog>
  </div>
</template>
<script>
import sasdk from './sasdkinit'
import { getMasterInfo } from '@/api/makefriend'
// import { Dialog } from 'vant'
export default {
  data () {
    return {
      show: false,
      qrcode: ''
    }
  },
  mounted () {
    sasdk.viewindex()
    // console.log('aaa')
    if (!this.$route.query.mid) {
      this.shownoqr()
    } else {
      this.getmaster()
    }
  },
  // created () {
  //   window.addEventListener('resize', this.checkScreen)
  //   this.checkScreen()
  // },
  // beforeDestroy () {
  //   window.removeEventListener('resize', this.checkScreen)
  // },
  methods: {
    getmaster () {
      getMasterInfo({
        masterId: this.$route.query.mid
      }).then(res => {
        if (res.code === 200 && res.data && res.data.wxQrCode) {
          this.qrcode = res.data.wxQrCode
        } else {
          this.shownoqr()
        }
      })
    },
    shownoqr () {
      this.show = true
    }
    // checkScreen () {
    //   const rect = document.documentElement.getBoundingClientRect()
    //   this.iswscreen = rect.width / rect.height > 4 / 7
    // }
  }
}
</script>
<style lang="scss" scoped>
  .friend-page{
    width:750px;
    height:100vh;
    margin:0 auto;
    position: relative;
    background: white;
  }
  .friend-bg{
    width:750px;
    height:800px;
    background: url('~@/assets/img/makefriend/teacherbg.png') no-repeat;
    background-color:#317EFF;
    background-size:746px 800px;
    background-position: center top;
  }
  .friend-whitebg{
    margin-top:-51px;
    width:750px;
    border-radius: 30px 30px 0 0;
    background:white;
  }
  .friend-content{
    position: relative;
    top:-53px;
  }
  .sub-btn{
    width:120px;
    height:120px;
    background: url('~@/assets/img/makefriend/pointer2.png') no-repeat;
    background-size:cover;
    margin:-60px auto 0;
  }
  .friend-word{
    height: 34px;
    font-size: 36px;
    font-family: FZLanTingHeiS-R-GB;
    font-weight: 400;
    color: #000000;
    line-height: 37px;
    text-align: center;
    margin-top:19px;
  }
  // .btn-height{
  //   position:fixed;
  //   margin:50px auto 0;
  //   bottom:0;
  //   left:13px;
  // }
  .friend-qrcode{
    border-radius: 10px;
    margin:0px auto;
    display:flex;
    justify-content: center;
    align-items: center;
    flex:1;
    img{
      width:500px;
      height:500px;
    }
  }
</style>
